import { Reveal } from "@/components/Reveal";
import { useSite, wa } from "@/context/ContentContext";
import WhatsAppIcon from "@/components/WhatsAppIcon";

export default function RoomCard({ room, index = 0 }) {
  const D = useSite();
  return (
    <Reveal delay={index * 0.09} className="h-full">
      <article data-testid={`room-card-${room.slug}`} className="group flex h-full flex-col">
        <div className="relative aspect-[4/3] overflow-hidden rounded-[1.75rem] shadow-premium transition-shadow duration-700 group-hover:shadow-lift">
          <img
            src={room.image}
            alt={room.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-[1200ms] ease-premium group-hover:scale-[1.06]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-charcoal-950/70 via-charcoal-950/10 to-transparent opacity-0 transition-opacity duration-700 group-hover:opacity-100" />
          <span className="absolute left-4 top-4 rounded-full border border-white/30 bg-white/15 px-4 py-1.5 font-accent text-[11px] uppercase tracking-[0.2em] text-white backdrop-blur-md">
            {room.capacity}
          </span>
          <a
            data-testid={`room-card-${room.slug}-whatsapp`}
            href={wa(D.site, `Merhaba, ${room.name} hakkında bilgi almak istiyorum.`)}
            target="_blank"
            rel="noopener noreferrer"
            className="absolute inset-x-4 bottom-4 flex translate-y-4 items-center justify-center gap-2 rounded-full bg-white/95 py-3.5 text-sm font-semibold text-charcoal-900 opacity-0 backdrop-blur transition-all duration-500 ease-premium hover:bg-white group-hover:translate-y-0 group-hover:opacity-100"
          >
            <WhatsAppIcon className="h-4 w-4 text-[#25D366]" />
            WhatsApp'tan Bilgi Al
          </a>
        </div>
        <div className="flex flex-1 flex-col pt-7">
          <div className="flex items-baseline justify-between gap-4">
            <h3 className="font-serif text-2xl tracking-tight text-charcoal-900">{room.name}</h3>
            <span className="shrink-0 font-accent text-xs uppercase tracking-[0.2em] text-gold-dark">
              {room.size}
            </span>
          </div>
          <p className="mt-3 flex-1 text-sm leading-relaxed text-muted-foreground">{room.desc}</p>
          <div className="mt-5 flex flex-wrap gap-2">
            {room.features.map((f) => (
              <span
                key={f}
                className="rounded-full border border-charcoal-900/10 px-3.5 py-1.5 text-xs text-charcoal-800/70 transition-colors duration-300 hover:border-gold/40 hover:text-gold-dark"
              >
                {f}
              </span>
            ))}
          </div>
        </div>
      </article>
    </Reveal>
  );
}
